import React from 'react';
import { Modal } from '../../components';
import { createResourceLocatorString } from '../../util/routes';

import RequestPriceForm from './RequestPriceForm/RequestPriceForm';

import css from './ListingPage.module.css';

const RequestPriceModal = props => {
  const {
    location,
    history,
    routes,
    isAuthenticated,
    author,
    authorDisplayName,
    requestPriceInProgress,
    requestPriceError,
    requestPriceModalOpen,
    setRequestPriceModalOpen,
    onSubmitRequestPrice,
    onManageDisableScrolling,
    // Prefilled message body. Used when the request comes from the specification
    // configurator, so the chosen designation and quantity travel with it instead
    // of the supplier receiving a bare "what does this cost?".
    initialMessage,
  } = props;

  const handleCloseModal = () => {
    setRequestPriceModalOpen(false);

    if (location.state?.requestPriceModalOpen) {
      const to = createResourceLocatorString('CartPage', routes);
      history.push(to);
    }
  };

  return (
    <Modal
      id="ListingPage.requestPriceModal"
      containerClassName={css.requestPriceModalContainer}
      isOpen={isAuthenticated && requestPriceModalOpen}
      onClose={handleCloseModal}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <RequestPriceForm
        key={requestPriceModalOpen}
        className={css.requestPriceForm}
        author={author}
        authorDisplayName={authorDisplayName}
        onSubmit={onSubmitRequestPrice}
        initialValues={initialMessage ? { message: initialMessage } : undefined}
        inProgress={requestPriceInProgress}
        requestPriceError={requestPriceError}
      />
    </Modal>
  );
};

export default RequestPriceModal;
